import React from "react";
// import { Navigate } from "react-router-dom";
import Add from "./Add";
import Edit from "./Edit";
import Screen from "../../layout/Screen";
import Overview from "./Overview";
import { useCompanyContext } from "../../context/CompanyContext";
// import { useAdminContext } from "../../context/admin/AdminContext";

// const ReturnHome = () => {
//   const { sysAdmin } = useAdminContext();
//   if (!sysAdmin || sysAdmin?.role !== "admin")
//     return (
//       <Navigate
//         replace
//         to="/"
//       />
//     );
//   else return null;
// };

export const Admin = () => {
  const { company } = useCompanyContext();
  return (
    <>
      {/* <ReturnHome /> */}
      <Screen title={
              company
                ? `${company?.name} - Admins Management`
                : "Admin Management"
            }><Overview /></Screen>
    </>
  );
};

export const AddAdmin = () => {
  const { company } = useCompanyContext();
  return (
    <>
      {/* <ReturnHome /> */}
      <Screen title={company ? `Add Admins in ${company?.name}` : "Add Admin"}><Add /></Screen>
    </>
  );
};

export const EditAdmin = () => {
  const { company } = useCompanyContext();
  return (
    <>
      {/* <ReturnHome /> */}
      <Screen title={company ? `Edit Admins in ${company?.name}` : "Edit Admin"}><Edit /></Screen>
    </>
  );
};
